import script from "./_SSRPath.vue?vue&type=script&lang=js"
export * from "./_SSRPath.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__